import { render } from "./contact.vue?vue&type=template&id=8caa03d4&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=8caa03d4&lang=scss&scoped=true"

import exportComponent from "D:\\Build Apps\\jlm_app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8caa03d4"]])

export default __exports__